import { render, staticRenderFns } from "./ProfileDisplay.vue?vue&type=template&id=4bc993c3&scoped=true&"
import script from "./ProfileDisplay.vue?vue&type=script&lang=js&"
export * from "./ProfileDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDisplay.vue?vue&type=style&index=0&id=4bc993c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc993c3",
  null
  
)

export default component.exports